import m from "mithril";
import _ from "underscore";
import {CellItem} from './cellItem'
import {XmlTagInfo} from "../xmlTagProvider";
import {SliderView} from "../../ui/items/sliderView";
import {XmlUtils} from "../utils";
import {ValidateResult} from "../contentType";

type TRange = { min: number, max: number, step: number };
type TLabels = { left: string|null, right: string|null, center: string|null };

export class SliderItem extends CellItem {
	public readonly initialValue: number;
    public readonly labels: TLabels;

	public readonly range: TRange;
    public readonly unit: string

	static fromXml(config: XmlTagInfo){
		return new SliderItem(config);
	}

	constructor(config: XmlTagInfo){
		super(config);
		const rangeNode = XmlUtils.childByName(config, "range");
		this.range = {
			min: parseInt(rangeNode.attributes['min'], 10),
			max: parseInt(rangeNode.attributes['max'], 10),
			step: parseInt(rangeNode.attributes['step'], 10)
		};
		this.initialValue = this.parseInitialValue(
            parseInt(config.attributes['initialValue']),
            config.attributes['initialValueInPercent'] === 'yes',
            this.range
        );
        this.unit = config.attributes["unit"] ?? '';
        this.labels = {
            left: XmlUtils.childByName(config, "labelLeft")?.value ?? null,
            center: XmlUtils.childByName(config, "labelCenter")?.value ?? null,
            right: XmlUtils.childByName(config, "labelRight")?.value ?? null,
        }

	}

    private parseInitialValue(initialValue: number, isPercent: boolean, range: TRange): number {
        if (!isPercent) {
            return initialValue;
        }
        return range.min + (range.max - range.min) * initialValue * 0.01;
    }

	getView() {
	    // @ts-ignore
		return m(SliderView.component, {cellItem: this});
	}

	onNavigatedTo(){
		this.set(this.getVariable());
	}

	validate (){
		const variable = this.getVariable();
		const valid = ! _.isUndefined(variable) && variable !== null;
		return valid ? ValidateResult.okResult() : ValidateResult.errorResult(this.questionary.messages.get("valuesCheckSlider"));
	}

	set(value:any) {
		this.setVariable(value);
        if (this.form.activeGlobalUnknown) {
            this.form.activeGlobalUnknown.set();
        }
		this.form.reValidate();
	}

}